module.exports = __webpack_public_path__ + "img/2-1_02.2096b343.jpg";